/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('CarRentalTypeTemplateEventArticleController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CarRentalTypeTemplateEventArticleFactory,
		FindAllCarRentalTypeTemplateEventArticlesByQueryParamsFactory,
		NoPagingCarRentalTypeTemplateEventArticleFactory,
		NoPagingCarRentalTypeFactory,
		NoPagingTemplateEventFactory,
		NoPagingArticleFactory,
		CarRentalTypeTemplateEventArticleFindArticleFilteredByArticleForRentalFactory
	) {
		$scope.carRentalTypeTemplateEventArticleList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeCarRentalTypeTemplateEventArticle)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeCarRentalTypeTemplateEventArticle);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeCarRentalTypeTemplateEventArticle = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('carrentaltypetemplateeventarticle.list.new');
		};

		$scope.goToEditState = function(carRentalTypeTemplateEventArticle) {
			// this overview is NOT mapped, it is the main overview
			$state.go('carrentaltypetemplateeventarticle.list.edit', {
				carRentalTypeTemplateEventArticleId: carRentalTypeTemplateEventArticle.id,
			});
		};

		$scope.getCarRentalTypeTemplateEventArticleList = function() {
			FindAllCarRentalTypeTemplateEventArticlesByQueryParamsFactory.query(
				{
					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.carRentalTypeTemplateEventArticleList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getCarRentalTypeTemplateEventArticleList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedCarRentalTypeTemplateEventArticleId = id;
			$('#deleteCarRentalTypeTemplateEventArticleConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			CarRentalTypeTemplateEventArticleFactory.delete(
				{ id: $scope.selectedCarRentalTypeTemplateEventArticleId },
				function() {
					$scope.loadAll();
					$('#deleteCarRentalTypeTemplateEventArticleConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteCarRentalTypeTemplateEventArticleConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
